import React from 'react'
import './Modal.scss'
import {IoCloseCircle} from 'react-icons/io5'

const Modal = ({toggleModal, handleToggle, form, title}) => {
    if (toggleModal) {
        return (
            <div className='modal'>
                <div
                    className='bg-white relative w-[80vw] md:w-1/2 lg:w-1/3 2xl:w-1/5 p-6 flex flex-col space-y-6 rounded shadow-md'>
                    <h3 className='text-left text-2xl text-black'>{title ?? "Modal Title"}</h3>
                    {form}
                    <IoCloseCircle onClick={handleToggle}
                                   className="absolute right-3 -top-3 text-red-600 text-2xl self-top cursor-pointer transition-all ease-in-out hover:scale-110"/>
                </div>

            </div>
        )
    }
    return (<></>)
}

export default Modal